import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const MetaMaskIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest} fillColor="currentColor" strokeColor="currentColor">
      <path
        d="M20.6481 2.67407L13.1528 8.24093L14.5389 4.95656L20.6481 2.67407Z"
        fill="#E2761B"
        stroke="#E2761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.34467 2.67407L10.7797 8.29366L9.46143 4.95656L3.34467 2.67407ZM17.9511 15.578L15.9548 18.6364L20.226 19.8115L21.4539 15.6458L17.9511 15.578ZM2.55371 15.6458L3.77405 19.8115L8.04524 18.6364L6.049 15.578L2.55371 15.6458Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.80446 10.4105L6.61426 12.2109L10.8553 12.3992L10.7047 7.84179L7.80446 10.4105ZM16.1886 10.4105L13.2508 7.78906L13.1529 12.3992L17.3864 12.2109L16.1886 10.4105ZM8.04552 18.6365L10.5917 17.3936L8.39204 15.6761L8.04552 18.6365ZM13.4015 17.3936L15.9551 18.6365L15.6011 15.6761L13.4015 17.3936Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.955 18.6365L13.4013 17.3936L13.6047 19.0583L13.5821 19.7589L15.955 18.6365ZM8.04541 18.6365L10.4183 19.7589L10.4032 19.0583L10.5915 17.3936L8.04541 18.6365Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4558 14.5761L8.33154 13.9509L9.8306 13.2654L10.4558 14.5761ZM13.5368 14.5761L14.1621 13.2654L15.6686 13.9509L13.5368 14.5761Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.04555 18.6365L8.40713 15.5782L6.04932 15.646L8.04555 18.6365ZM15.5936 15.5782L15.9552 18.6365L17.9514 15.646L15.5936 15.5782ZM17.3864 12.2109L13.1529 12.3993L13.5446 14.5763L14.1698 13.2656L15.6764 13.951L17.3864 12.2109ZM8.3318 13.951L9.83839 13.2656L10.4561 14.5763L10.8553 12.3993L6.61429 12.2109L8.3318 13.951Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.61426 12.2109L8.39204 15.6761L8.33177 13.951L6.61426 12.2109ZM15.6764 13.951L15.6011 15.6761L17.3864 12.2109L15.6764 13.951ZM10.8553 12.3993L10.4561 14.5763L10.9532 17.145L11.0662 13.7627L10.8553 12.3993ZM13.1529 12.3993L12.9495 13.7552L13.0399 17.145L13.5446 14.5763L13.1529 12.3993Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5443 14.5762L13.0396 17.1449L13.4012 17.3935L15.6008 15.676L15.6762 13.9509L13.5443 14.5762ZM8.33154 13.9509L8.39181 15.676L10.5914 17.3935L10.953 17.1449L10.4558 14.5762L8.33154 13.9509Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5821 19.7589L13.6047 19.0583L13.4164 18.8926H10.5765L10.4032 19.0583L10.4183 19.7589L8.04541 18.6365L8.87404 19.3144L10.5539 20.482H13.439L15.1264 19.3144L15.955 18.6365L13.5821 19.7589Z"
        fill="#C0AD9E"
        stroke="#C0AD9E"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4014 17.3936L13.0399 17.145H10.9532L10.5916 17.3936L10.4033 19.0584L10.5766 18.8927H13.4165L13.6048 19.0584L13.4014 17.3936Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9642 8.60251L21.6045 5.52906L20.6479 2.67407L13.4012 8.0526L16.1884 10.4104L20.1281 11.563L21.0019 10.546L20.6253 10.2748L21.2279 9.72492L20.7609 9.36334L21.3635 8.90383L20.9642 8.60251ZM2.39551 5.52906L3.03581 8.60251L2.62903 8.90383L3.23167 9.36334L2.77216 9.72492L3.37479 10.2748L2.99814 10.546L3.86443 11.563L7.80417 10.4104L10.5914 8.0526L3.34466 2.67407L2.39551 5.52906Z"
        fill="#763D16"
        stroke="#763D16"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1281 11.5629L16.1884 10.4104L17.3861 12.2108L15.6008 15.6759L17.9511 15.6458H21.4539L20.1281 11.5629ZM7.80418 10.4104L3.86445 11.5629L2.55371 15.6458H6.049L8.39175 15.6759L6.61397 12.2108L7.80418 10.4104ZM13.1526 12.3991L13.4012 8.05259L14.5462 4.95654H9.46143L10.5914 8.05259L10.855 12.3991L10.9454 13.7701L10.953 17.1449H13.0396L13.0547 13.7701L13.1526 12.3991Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
